import { InfoCircleOutlined } from '@ant-design/icons';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { type IInfoWidget } from './IInfoWidget.ts';
import { InfoWidgetComponent } from './InfoWidgetComponent.tsx';
import {
  InfoWidgetConfigComponent,
  InfoWidgetConfigSchema,
} from './InfoWidgetConfigComponent.tsx';

/**
 * Tipo del componente di visualizzazione di un box informativo.
 */
export const InfoWidgetType: IWidgetType<IInfoWidget> = {
  icon: <InfoCircleOutlined />,
  type: WidgetType.Info,
  mainType: WidgetMainType.Graphic,
  category: WidgetCategory.Graphic,
  name: 'Box informativo',
  hasValue: false,
  formComponent: InfoWidgetComponent,
  configComponent: InfoWidgetConfigComponent,
  configValidator: InfoWidgetConfigSchema,
  previewComponent: InfoWidgetComponent,
  translationSchema: tran.widget({
    body: tran.rte(),
    layout: tran.object({
      collapsibleBody: tran.rte(),
      collapsibleExpandText: tran.string(),
      collapsibleCollapseText: tran.string(),
    }),
  }),
  rules: [],
};
